import type {
    DownloaderPage,
    ModalStatus,
    StateWithDownloader,
} from './reducer'

export const getDownloaderModalState = (
    state: StateWithDownloader,
): ModalStatus => state.downloader.modalStatus
export const getDownloaderJob = (state: StateWithDownloader): string =>
    state.downloader.job
export const getDownloaderPages = (
    state: StateWithDownloader,
): DownloaderPage[] => state.downloader.pages
export const getDownloaderConversionOption = (
    state: StateWithDownloader,
): boolean => state.downloader.convert
export const getDownloaderSubrevisionOption = (
    state: StateWithDownloader,
): boolean => state.downloader.subrevisions
export const getDownloaderCount = (state: StateWithDownloader) =>
    state.downloader.count
export const getDownloaderSize = (state: StateWithDownloader) =>
    state.downloader.size
